import React from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import DatatableTables from "./DatatableTables"
import MetaTag from "components/Common/Meta-tag"

function Groups() {
  return (
    <>
      <MetaTag title={"All Groups"} />

      <div className="page-content">
        <Breadcrumbs title="Dashboard" breadcrumbItem="All Groups" />
        <Container fluid>
          <div className="container-fluid">
            <DatatableTables />
          </div>
        </Container>
      </div>
    </>
  )
}

export default Groups
